// extracted by mini-css-extract-plugin
export default {"buttonContainer":"MapsCreationPage_buttonContainer__W-RIH","nameInput":"MapsCreationPage_nameInput__nCKUL","content":"MapsCreationPage_content__8F2Yi"};